module.exports = __webpack_public_path__ + "244c50c70c420903d2fc14b549f18487.fbx";